import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let fetchPromise = null;

export default function useCMS() {
  const [cms, setCms] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) { setCms(cache); setLoading(false); return; }
    if (!fetchPromise) {
      fetchPromise = axios.get(`${API}/api/cms/public`)
        .then(r => { cache = r.data; return r.data; })
        .catch(() => null)
        .finally(() => { fetchPromise = null; });
    }
    fetchPromise.then(data => { setCms(data); setLoading(false); });
  }, []);

  return { cms, loading };
}

/** Invalidate cache (call after admin saves) */
export function invalidateCMS() {
  cache = null;
  fetchPromise = null;
}
